<template>
  <div class="work-item text-center">
    <a-row type="flex">
      <a-col :span="24">
        <a-badge>
          <a-avatar class="work-icon" @click="$emit('clicked', numero)" shape="square" size="large" :style="{ 'background-color': this.colors[this.letter.toLowerCase()] }">
            {{ letter }}
            <p class="work-icon-date">{{ creationDate }}</p>
          </a-avatar>
          <a-icon class="del-badge" @click="handleDeleteWorkBtnClick(numero, title)" slot="count" type="close" />
        </a-badge>
      </a-col>
    </a-row>
    <a-row type="flex">
      <a-col :span="24" class="work-label-container">
        <p class="work-label inline">{{ title }} </p>
        <template v-if="remediation">
          <a-tooltip placement="top" >
            <template slot="title">
              <span>Un détail du travail a fait l'objet d'une remarque</span>
            </template>
            <a-icon class="work-label-icon inline" type="exclamation-circle" theme="filled" />
          </a-tooltip>
        </template>
        <template v-else-if="valid">
          <a-tooltip placement="top" >
            <template slot="title">
              <span>Tous les détails du travail ont été validés</span>
            </template>
            <a-icon class="work-label-icon inline" type="check-circle" theme="filled" />
          </a-tooltip>
        </template>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import WorkService from '../../services/work_service'

export default {
  name: 'WorkItem',
  props: {
    numero: Number,
    title: String,
    creationDate: String
  },
  data: function () {
    return {
      letter: 'a',
      valid: false,
      remediation: false,
      colors: {
        a: '#1abc9c',
        b: '#16a085',
        c: '#f1c40f',
        d: '#f39c12',
        e: '#2ecc71',
        f: '#27ae60',
        g: '#e67e22',
        h: '#d35400',
        i: '#3498db',
        j: '#2980b9',
        k: '#e74c3c',
        l: '#c0392b',
        m: '#9b59b6',
        n: '#8e44ad',
        o: '#34495e',
        p: '#2c3e50',
        q: '#95a5a6',
        r: '#7f8c8d',
        s: '#c0392b',
        t: '#8e44ad',
        u: '#1e8bc3',
        v: '#16a085',
        w: '#f7ca18',
        x: '#e87e04',
        y: '#67809f',
        z: '#2e3131',
        1: '#1abc9c',
        2: '#16a085',
        3: '#f1c40f',
        4: '#f39c12',
        5: '#2ecc71',
        6: '#27ae60',
        7: '#e67e22',
        8: '#d35400',
        9: '#3498db',
        0: '#2980b9'
      }
    }
  },
  async created () {
    // Une fois que le composant s'est affiché, on détermine la première lettre du travail
    this.letter = this.title.charAt(0)
    // api : Récupérer le status du travail
    const response = await WorkService.getStatus(this.numero)
    if (response) {
      const data = response.data.data
      if (data.valide) {
        this.valid = true
      } else if (data.remediation) {
        this.remediation = true
      }
    }
  },
  methods: {
    handleDeleteWorkBtnClick (numero, title) {
      this.$confirm({
        title: 'Êtes-vous sûr ?',
        content: 'Cela aura pour effet de supprimer ' + title + ' définitivement.',
        okText: 'Oui',
        okType: 'danger',
        cancelText: 'Non',
        onOk: () => {
          console.log('OK')
          this.$emit('onDelete', numero)
        },
        onCancel () {
          console.log('Cancel')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.work-item{
  margin-top: 10px;
}
.work-icon{
  border-radius: 20px;
  background-color: #f56a00;
  width: 130px;
  height: 130px;
  font-size: 3em;
  cursor: pointer;
}
.work-icon-date{
  font-size: 0.3em;
  margin-top: 10px;
}
.work-icon:hover{
  border: 2.5px solid #40a9ff;
}
.work-icon:hover + .del-badge{
  visibility: visible;
  opacity: 1;
}
.work-icon:hover .work-icon-date{
  visibility: visible;
  opacity: 1;
}
.del-badge:hover{
  visibility: visible;
  opacity: 1;
}
.del-badge {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
  padding-top: 3px;
  color: white;
  height: 20px;
  border-radius: 10px;
  min-width: 20px;
  background: gray;
  text-align: center;
  z-index: 10;
}
.del-badge:hover{
  cursor: pointer;
}
.work-label{
  font-size: 1.5em;
}
.work-label-icon{
  font-size: 1.2em;
}
</style>
